import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Catch-all: unknown paths land on /login. RequireAuth re-redirects to the
 * right place if the user is already signed in.
 */
export const Route = createFileRoute('/$')({
  beforeLoad: () => {
    throw redirect({ to: '/login', replace: true });
  },
});
